"use client"

import { useEffect } from "react";

import { cookieName } from '@/lib/cookies'

export default function AttributionTracker() {
  useEffect(() => {
    let referrerUrl = window.location.href;

    if (!window.location.search) {
      let source = "direct";

      if (document.referrer) {
        source = encodeURIComponent(document.referrer);
      }
      
      referrerUrl += `?utm_source=${source}&utm_content=pride`;
    }

    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);

    document.cookie = `${cookieName}=${encodeURIComponent(referrerUrl)}; path=/; expires=${expires.toUTCString()}`;
  }, []);

  return null;
}
